import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import $ from 'jquery';
import { verificationCode, forgotPassword } from '@/api/user';
import { isPhone, isEmail } from '@/utils/validate';
var sha256 = require('js-sha256');
export default {
  data: function data() {
    return {
      isActive: false,
      userName: '',
      verificationCode: '',
      password: '',
      verifyPassword: '',
      countryCode: localStorage.getItem('countryCode') || '+86',
      type: 'password',
      verifyType: 'password'
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {
    input: function input() {
      if (this.userName.trim() !== '' && this.password.trim() !== '' && this.verificationCode.trim() !== '' && this.verifyPassword.trim() !== '' && this.verifyPassword === this.password) {
        if (isPhone(this.userName) || isEmail(this.userName)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      } else {
        this.isActive = false;
      }
    },
    focus: function focus(dom) {
      $(dom).css('border-image', '-webkit-linear-gradient(#6EDCF5 0%, #6EDCF5 100%) 0 0 100 0');
    },
    blur: function blur(dom) {
      $(dom).css('border-image', 'none');
    },
    showWord: function showWord(type) {
      if (type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
    showVerifyWord: function showVerifyWord(type) {
      if (type === 'password') {
        this.verifyType = 'text';
      } else {
        this.verifyType = 'password';
      }
    },
    confirm: function confirm() {
      var _this = this;
      var params = {};
      params.userName = this.userName;
      params.verificationCode = this.verificationCode;
      params.password = sha256(this.password);
      if (this.userName.trim() !== '' && this.password.trim() !== '' && this.verificationCode.trim() !== '' && this.verifyPassword.trim() !== '' && this.verifyPassword === this.password) {
        if (isPhone(this.userName)) {
          params.countryCode = this.countryCode;
          params.accountType = 1;
        } else {
          if (isEmail(this.userName)) {
            params.accountType = 2;
            delete params.countryCode;
          } else {
            this.$toast('用户名格式不正确');
            return;
          }
        }
      } else {
        if (this.verifyPassword === this.password) {
          this.$toast('请输入完整信息');
        } else {
          this.$toast('两次输入的密码不一致');
        }
        return;
      }
      forgotPassword(params).then(function (res) {
        if (res.code === 0) {
          _this.$toast('发送完成');
        } else {
          _this.$toast(res.message);
        }
      });
    },
    send: function send() {
      var _this2 = this;
      var params = {};
      params.targetName = this.userName;
      params.operationType = 0;
      if (isPhone(this.userName)) {
        params.countryCode = this.countryCode;
        params.targetType = 1;
      } else {
        if (isEmail(this.userName)) {
          params.targetType = 2;
          delete params.countryCode;
        } else {
          if (this.userName) {
            this.$toast('用户名格式不正确');
          } else {
            this.$toast('请输入用户名');
          }
          return;
        }
      }
      verificationCode(params).then(function (res) {
        if (res.code === 0) {
          _this2.$toast('发送完成');
        } else {
          _this2.$toast(res.message);
        }
      });
    },
    getCountry: function getCountry() {
      this.$router.push({
        path: '/selectCountry'
      });
    },
    back: function back() {
      this.$router.back();
    },
    toLogin: function toLogin() {
      this.$router.push({
        path: '/login'
      });
    }
  }
};